<template>
  <scrollactive
    class="my-nav"
    id="menu-bar"
    active-class="active"
    :offset="scrollactive_offset"
    :scrollOffset="scrollactive_scroll_offset"
    :duration="scrollactive_duration"
    bezier-easing-value=".5,0,.35,1"
  >
    <navbar
      position="fixed"
      type="default"
      :transparent="transparent"
      :color-on-scroll="colorOnScroll"
      menu-classes="ml-auto"
    >
      <!-- Left Logo -->
      <template>
        <div v-popover:popover1 class="navbar-brand" @click="go_home">
          <router-link :to="{ name: 'Home' }">
            {{ transformYear($t("menu.header_platform_name")) }}
          </router-link>
        </div>
        <!-- <el-popover ref="popover1" popper-class="popover" placement="bottom" width="200" trigger="hover">
                    <div class="popover-body">
                        Design & Code by AgriWeather.
                    </div>
                </el-popover> -->
      </template>

      <!-- Right Menu -->
      <template slot="navbar-menu">
        <!-- <li class="nav-item">
                    <a class="nav-link scrollactive-item" href="./#section-summary">
                        <i class="fas fa-info-circle"></i> 專案介紹
                    </a>
                </li> -->
        <li class="nav-item">
          <!-- <router-link class="nav-link" :to="{ name: 'Home', hash: '#section-map' }">
                        <i class="fas fa-map"></i> 產區地圖
                    </router-link> -->
          <a class="nav-link scrollactive-item" href="#section-map">
            {{ $t("menu.flowering_map") }}
          </a>
        </li>

        <drop-down tag="li" class="nav-item">
          <template slot="title">
            <a class="dropdown-toggle nav-link" data-toggle="dropdown">
              <i class="fas fa-globe"></i>
              {{ $t("menu.language") }}
            </a>
          </template>

          <nav-link :to="{ name: 'Home', query: { lang: 'ch' } }">
            正體中文
          </nav-link>

          <nav-link :to="{ name: 'Home', query: { lang: 'en' } }">
            English
          </nav-link>

          <nav-link :to="{ name: 'Home', query: { lang: 'jp' } }">
            日本語
          </nav-link>
        </drop-down>

        <li class="nav-item">
          <!-- <a
            class="nav-link scrollactive-item"
            href="https://romantichakka.com/"
          >
            {{ $t("menu.main_platform_name") }}
          </a> -->
          <router-link :to="{ name: 'RomanticHakka' }" class="nav-link">
            {{ $t("menu.main_platform_name") }}
          </router-link>
        </li>
      </template>
    </navbar>
  </scrollactive>
</template>

<script>
import { mapState } from "vuex";
import { DropDown, NavbarToggleButton, Navbar, NavLink } from "@/components";

import { Popover } from "element-ui";

export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover,
  },
  data() {
    return {
      scrollactive_offset: 50, // Amount of space between top of screen and the section to highlight. ( Usually your fixed header's height )
      scrollactive_scroll_offset: 60, // Amount of space between the top of the screen and the section to highlight when clicking a scrollactive item to scroll.
      scrollactive_duration: 600,
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user_language: (state) => state.user.language,
    }),
  },
  methods: {

    //NOTE - 將年份動態帶入描述文字中
    transformYear(description = '') {
      const year_tw = new Date().getFullYear() - 1911;
      const year_en = new Date().getFullYear();

      if (description.includes("{year_tw}")) {
        return description.replace("{year_tw}", year_tw);
      }

      return description.replace("{year_en}", year_en);
    },

    go_home() {
      let body = document.body; // For Safari
      let html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the html level, unless else is specified. Therefore, we use the documentElement property for these browsers

      body.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
      html.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-brand a {
  cursor: pointer;
  color: #ffffff;

  &:hover,
  &:active,
  .active.router-link-active {
    text-decoration: none;
  }
}

.nav-link {
  font-size: 1rem !important;
  font-weight: 500;
}

.nav-link.active {
  font-weight: 600 !important;
}

.header-image {
  height: 18px;
  margin-bottom: 3px;
  vertical-align: middle;
}
</style>
